export class VerticalNotLaunchedError extends Error {
  fallbackUrl: string;
  constructor(fallbackUrl: string) {
    super();
    this.fallbackUrl = fallbackUrl;
  }
}
